export const API_HOST =
  process.env.REACT_APP_API_HOST || 'http://localhost:8000';
export const PDF_EXPORT_API_HOST =
  process.env.PDF_EXPORT_API_HOST || 'http://localhost:5001/api';
export const BOLETOS_SERVICE_HOST =
  process.env.REACT_APP_BOLETOS_SERVICE_HOST || 'http://127.0.0.1:8001';
export const MOODLE_HOST =
  process.env.REACT_APP_MOODLE_HOST || 'http://localhost';
export const ACTIVITY_GRADE_DECIMAL_PLACES =
  +process.env.REACT_APP_ACTIVITY_GRADE_DECIMAL_PLACES || 2;
export const CURRENT_PLACE = {
  name: process.env.REACT_APP_CURRENT_PLACE_NAME,
  address: process.env.REACT_APP_CURRENT_PLACE_ADDRESS,
};
export const CHAT_ID = process.env.REACT_APP_CHAT_ID;
export const SUITE_SHARE_ID = process.env.REACT_APP_SUITE_SHARE_ID;
export const WHATS_APP_PHONE = process.env.REACT_APP_WHATS_APP_PHONE;
export const REACT_APP_LABEL_DIPLOMA =
  process.env.REACT_APP_LABEL_DIPLOMA || 'DIPLOMADO';

if (Number.isNaN(ACTIVITY_GRADE_DECIMAL_PLACES)) {
  throw Error(
    '`ACTIVITY_GRADE_DECIMAL_PLACES` setting should be a valid integer.'
  );
}

export const LESSON_STATUS_COLORS = {
  1: '#BABFBF',
  2: '#B77474',
  3: '#6CAA64',
  4: '#CC943C',
  5: '#969292',
};

export const LANCAMENTO_STATUS_COLORS = {
  1: '#da8a38',
  2: '#ACACAE',
  3: '#ACACAE',
  4: '#ACACAE',
  5: '#6caa63',
  6: '#b77474',
  7: '#a39161',
  11: '#6caa63',
  12: '#FF0000',
  14: '#6caa63',
  15: '#6caa63',
  16: '#6caa63',
  17: '#6caa63',
  19: '#6caa63',
  21: '#FF0000',
  22: '#6caa63',
  25: '#6caa63',
  32: '#b77474',
};

export const TEACHING_PLAN_STATUS_COLORS = {
  1: '#B77474', // Não preenchido
  2: '#23689B', // Preenchendo
  3: '#039F97', // Preenchido
  4: '#DA8A38', // Proposta de melhoria
  5: '#A39161', // Validado CN
  6: '#6CAA63', // Aprovado
  7: '#9B9B9B', // Não verificado
};

export const FEATURES = {
  ACTIVITY_LIST: ['alunos_presentes_no_card_atividades'],
  CRONOGRAMA_AULAS: ['material_didatico_no_cronograma'],
};

export const TICKET_CATEGORY_URLS = {
  1: 'retificacao-frequencia',
  2: 'retificacao-nota',
  3: 'troca-turma',
  4: 'DIV',
  5: 'DEC',
  6: 'HIS',
  7: 'UNI',
  8: 'segunda-chamada',
  9: 'frequencia-fora-do-prazo',
  10: 'disciplina-informada/tipo/1',
  11: 'dependencia',
  13: 'matricula-por-disciplina',
  50100: 'horas_complementares',
};

export const TICKET_CATEGORY_ENUMS = {
  RETIFICACAO_FREQUENCIA: 1,
  RETIFICACAO_NOTA: 2,
  TROCA_TURMA: 3,
  SEGUNDA_CHAMADA: 8,
  FREQUENCIA_FORA_DO_PRAZO: 9,
  DISCIPLINA_INFORMADA_TIPO_1: 10,
};

export const TICKET_STATUS_ENUM = {
  DEFERIDO: 1,
  INDEFERIDO: 2,
  EM_ANALISE: 3,
  CANCELADO_PELO_REQUERENTE: 4,
  AGUARDANDO_PAGAMENTO: 5,
  ENTREGUE: 6,
  APROVADO_PELA_SECRETARIA: 7,
  PAGAMENTO_CONFIRMADO: 8,
};

export const TICKET_CATEGORIES_ENUM = {
  REVISAO_DE_FREQUENCIA: 1,
  REVISAO_DE_NOTA: 2,
  PEDIDO_DE_DECLARAÇAO_EXCEPCIONAL: 5,
  HISTORICO_ESCOLAR_INATIVO: 6,
  SOLICITAÇAO_DE_EXAME_ESPECIAL: 8,
  FREQUENCIA_FORA_DO_PRAZO: 9,
  DISPENSA_DE_DISCIPLINA: 10,
  TRANSFERENCIA_INTERNA_DE_CAMPO_DE_PRATICA: 21,
  OPÇOES_DE_DISCIPLINAS_MESTRADO: 43,
  OPORTUNIDADE_DE_APRESENTAÇAO_DE_TCC_BANCA: 50,
  VIA_CERTIFICADO: 52,
  VIA_CRACHA_DE_ESTUDANTE: 53,
  OUTROS_SERVIÇOS_MESTRADO: 54,
  DECLARAÇAO_DE_CONCLUSAO_DE_CURSO: 57,
  DECLARAÇAO_DE_COMPARECIMENTO: 59,
  DECLARAÇAO_DE_MATRICULA: 60,
  EMENTA_DE_DISCIPLINA_CURSADA: 61,
  REABERTURA_DO_PRAZO_DE_TRABALHO_FINAL_DO_CURSO_ORIENTAÇAO_E_BANCA: 62,
  REVISAO_DE_PROVA: 64,
  TRANSFERENCIA_DE_TURMA: 65,
  PROCESSO_DE_CERTIFICAÇAO: 66,
  AGENDAMENTO_NAAP_PAIRE: 70,
  CANCELAMENTO_DE_MATRICULA: 71,
  ENTREGA_DE_DOCUMENTAÇAO: 77,
  DISPENSA_DE_DISCIPLINA_MESTRADO: 78,
  NADA_CONSTA_FINANCEIRO: 79,
  NADA_CONSTA_SERVIÇO_SOCIAL: 80,
  SEGUNDA_CHAMADA_DE_PROVA: 81,
  REPOSIÇAO_DE_DISCIPLINA: 82,
  RETORNO_AO_CURSO: 84,
  TRANSFERENCIA_INTERNA_DE_CURSO: 92,
  REGISTRO_DE_ESTORNO_DE_PAGAMENTO: 95,
  CURSO_DE_ACLS: 100,
  SOLICITAÇAO_DE_DESCONTO: 500,
  EMITIR_CERTIFICADO: 1000,
  DISCIPLINA_ISOLADA_MESTRADO: 5000,
  ALTERAÇAO_DE_DADOS_CADASTRAIS: 5001,
  DECLARAÇAO_DE_DOCENTE: 5002,
  ENTREGA_DA_VERSAO_FINAL_DO_TRABALHO_DE_CONCLUSAO_DE_CURSO: 5003,
  SOLICITAÇAO_DE_REEMBOLSO: 5004,
  REGIME_ESPECIAL_DE_ESTUDOS_SITUAÇAO_DE_SAUDE: 5005,
  VERIFICAÇAO_DE_SITUAÇAO_ACADEMICA: 5007,
  HISTORICO_ESCOLAR: 5008,
  ENTREGA_VERSAO_FINAL_DISSERTAÇAO_MESTRADO: 5010,
  CANCELAMENTO_DE_DISCIPLINA_MESTRADO: 5020,
  PRORROGAÇAO_DO_PRAZO_PARA_DEFESA_DISSERTAÇAO_MESTRADO: 5100,
  MODIFICAÇAO_DE_MATRICULA_MESTRADO: 5121,
  TRANCAMENTO_DE_MATRICULA_MESTRADO: 6000,
  TRANCAMENTO_DE_MATRICULA_RESIDENCIA_MEDICA: 6003,
  DECLARAÇAO_DE_MATRICULA_MESTRADO: 7000,
  DECLARAÇAO_DE_CONCLUSAO_MESTRADO: 7001,
  HISTORICO_ESCOLAR_MESTRADO: 7002,
  ENVIO_DE_CERTIFICADO_POR_MEIO_DE_SERVIÇO_DE_POSTAGEM: 7003,
  REGISTRO_DE_CERTIFICADOS: 7015,
  ATRIBUIÇAO_DE_CREDITOS_MESTRADO: 8000,
  REGIME_ESPECIAL_DE_ESTUDOS_MESTRADO: 50030,
  DECLARAÇAO_DE_MATRICULA_RESIDENCIA_MEDICA: 50031,
  HISTORICO_ESCOLAR_AVALIAÇAO_DE_DESEMPENHO_RESIDENCIA_MEDICA: 50032,
  SOLICITAÇAO_DE_EXAME_ESPECIAL_RESIDENCIA_MEDICA: 50033,
  COMPLEMENTACAO_DE_CARGA_HORARIA: 50100,
};

export const ACTIVE_CURRICULUM_STATUS = 13;

export const LESSON_TIMES = [
  {
    start_time: '07:00',
    end_time: '07:50',
  },
  {
    start_time: '07:50',
    end_time: '08:40',
  },
  {
    start_time: '08:55',
    end_time: '09:45',
  },
  {
    start_time: '09:45',
    end_time: '10:35',
  },
  {
    start_time: '10:50',
    end_time: '11:40',
  },
  {
    start_time: '11:40',
    end_time: '12:30',
  },
  {
    start_time: '13:30',
    end_time: '14:20',
  },
  {
    start_time: '14:20',
    end_time: '15:10',
  },
  {
    start_time: '15:25',
    end_time: '16:15',
  },
  {
    start_time: '16:15',
    end_time: '17:05',
  },
  {
    start_time: '17:20',
    end_time: '18:10',
  },
  {
    start_time: '18:10',
    end_time: '19:00',
  },
  {
    start_time: '19:00',
    end_time: '19:50',
  },
  {
    start_time: '19:50',
    end_time: '20:40',
  },
  {
    start_time: '20:55',
    end_time: '21:45',
  },
  {
    start_time: '21:45',
    end_time: '22:35',
  },
];

export const WEEKDAYS = [
  {
    name: 'Segunda-feira',
    abbreviation: 'SEG',
    code: 0,
  },
  {
    name: 'Terça-feira',
    abbreviation: 'TER',
    code: 1,
  },
  {
    name: 'Quarta-feira',
    abbreviation: 'QUA',
    code: 2,
  },
  {
    name: 'Quinta-feira',
    abbreviation: 'QUI',
    code: 3,
  },
  {
    name: 'Sexta-feira',
    abbreviation: 'SEX',
    code: 4,
  },
  {
    name: 'Sábado',
    abbreviation: 'SAB',
    code: 5,
  },
];

export const OFFER_TYPES = {
  HALF_YEARLY: 1,
  YEARLY: 2,
};

export const STATUS_LANCAMENTO = {
  PARCIALMENTE_PAGA: 4,
  PAGO: 5,
  COBRANCA_JURIDICA: 12,
  PAGO_DEVOLVIDO: 19,
};

export const TIPO_PAGAMENTO = {
  MATRICULA: 1,
  MENSALIDADE: 2,
  PROTOCOLO: 3,
};

export const TIPOS_PAGAMENTO_COM_DEVOLUCAO = [
  TIPO_PAGAMENTO.MATRICULA,
  TIPO_PAGAMENTO.MENSALIDADE,
  TIPO_PAGAMENTO.PROTOCOLO,
];

export const devices = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
};

export default API_HOST;

export const CERTIFICATE_STATUS = [
  { value: 'draft', label: 'Rascunho' },
  { value: 'sent', label: 'Enviado para assinatura' },
  { value: 'partial_signed', label: 'Assinado parcialmente' },
  { value: 'signed', label: 'Totalmente assinado' },
  { value: 'cancelled', label: 'Cancelado' },
  { value: 'error', label: 'Erro' },
];

export const STUDENT_STATUS = {
  CANCELADO: 12,
  CURSANDO: 13,
  DESISTENTE: 14,
  FORMADO: 15,
  PENDENTE: 16,
  RESERVA_VAGA: 17,
  TRANCADO: 18,
  TRANSF_CURRICULAR: 19,
  TRANSF_EXTERNA: 20,
  TRANSF_INTERNA: 21,
  INTEGRALIZED: 22,
  AGUARDANDO_TCC: 25,
};
